export const BACKBONE_ANGLES = ["omega", "phi", "psi"]

export const ANGLE_ORDER_MAP = {"omega": 0, "phi": 1, "psi": 2, "chi1": 3, "chi2": 4, "chi3": 5, "chi4": 6, "chi5": 7}
export const RAMA_ANGLES = ["phi", "psi"]
export const AMINO_ACID_ANGLES = {
    ALA: {rota: []},
    GLY: {rota: []},
    CYS: {rota: ["chi1"]},
    SER: {rota: ["chi1"]},
    VAL: {rota: ["chi1"]},
    THR: {rota: ["chi1"]},
    ILE: {rota: ["chi1", "chi2"]},
    LEU: {rota: ["chi1", "chi2"]},
    PHE: {rota: ["chi1", "chi2"]},
    TRP: {rota: ["chi1", "chi2"]},
    TYR: {rota: ["chi1", "chi2"]},
    ASP: {rota: ["chi1", "chi2"]},
    HIS: {rota: ["chi1", "chi2"]},
    ASN: {rota: ["chi1", "chi2"]},
    PRO: {rota: ["chi1", "chi2", "chi3"]},
    GLN: {rota: ["chi1", "chi2", "chi3"]},
    GLU: {rota: ["chi1", "chi2", "chi3"]},
    MET: {rota: ["chi1", "chi2", "chi3"]},
    LYS: {rota: ["chi1", "chi2", "chi3", "chi4"]},
    ARG: {rota: ["chi1", "chi2", "chi3", "chi4", "chi5"]}
}

export const getAminoAcidAngleVector = function (aminoAcid, dihedralAngles, geometryList){

    const flattenedGeometryList = geometryList.flatMap(geometry => {
        if (geometry === "rota") {
            return AMINO_ACID_ANGLES[aminoAcid].rota
        } else if (geometry === "rama") {
            return RAMA_ANGLES
        } else if (geometry === "backbone") {
            return BACKBONE_ANGLES
        } else if (geometry === "joint"){
            return BACKBONE_ANGLES.concat(AMINO_ACID_ANGLES[aminoAcid].rota)
        } else {
            return geometry
        }
    })

    return flattenedGeometryList.map(geometry => dihedralAngles[geometry])
}

export const DIHEDRAL_ANGLE_GROUP_DESCRIPTIONS = [
    ["Joint", "consider <ω, φ, ψ, χ₁, ..., Xₙ> all combined"],
    ["All_Individuals", "consider all singleton dihedral angles"],
    ["Rota", "consider only side chain dihedral angles"],
    ["Rama", "consider only Ramachandran (<φ,ψ>) dihedral angles"],
    ["Backbone", "consider all main chain (<ω,φ,ψ>) dihedral angles (i.e, including ω)"],
    ["ω", "consider singleton dihedral ω angle"],
    ["φ", "consider singleton dihedral φ angle"],
    ["ψ", "consider singleton dihedral ψ angle"],
    ["χ₁", "consider singleton dihedral χ₁ angle (where applicable)"],
    ["χ₂", "consider singleton dihedral χ₂ angle (where applicable)"],
    ["χ₃", "consider singleton dihedral χ₃ angle (where applicable)"],
    ["χ₄", "consider singleton dihedral χ₄ angle (where applicable)"],
    ["χ₅", "consider singleton dihedral χ₅ angle (where applicable)"],
]